export const GET_ORG_ACCOUNTS = "get_org_accounts";
export const GET_ORG_ACCOUNTS_SUCCESS = "get_org_accounts_success";
export const GET_ORG_ACCOUNTS_FAILURE = "get_org_accounts_failure";
export const GET_ORG_USERS_SUCCESS = "get_org_users_success";
export const GET_ORG_SUCCESS = "get_org_success";

export const UPDATE_ORG_ACCOUNT = "update_org_account";
export const UPDATE_ORG_ACCOUNT_SUCCESS = "update_org_account_success";
export const UPDATE_ORG_ACCOUNT_FAILURE = "update_org_account_failure";

export const ADD_ORG_ACCOUNT = "add_org_account";
export const ADD_ORG_ACCOUNT_SUCCESS = "add_org_account_success";
export const ADD_ORG_ACCOUNT_FAILURE = "add_org_account_failure";

export const DELETE_ORG_ACCOUNT = "delete_org_account";
export const DELETE_ORG_ACCOUNT_SUCCESS = "delete_org_account_success";
export const DELETE_ORG_ACCOUNT_FAILURE = "delete_org_account_failure";

export const DELETE_ORG_USER = "delete_org_user";
export const DELETE_ORG_USER_SUCCESS = "delete_org_user_success";
export const DELETE_ORG_USER_FAILURE = "delete_org_user_failure";

export const CLEAR_ALL_MESSAGES = "clear_all_messages";
export const CLEAR_ALL_MESSAGES_SUCCESS = "clear_all_messages_success";

export const CLEAR_SUCCESS_MESSAGES = "clear_success_messages";
export const CLEAR_SUCCESS_MESSAGES_SUCCESS = "clear_success_messages_success";

export const CLEAR_FAILURE_MESSAGES = "clear_failure_messages";
export const CLEAR_FAILURE_MESSAGES_SUCCESS = "clear_failure_messages_success";

export const GET_ORG_ACCOUNT_WORKLOADS = "get_org_account_workloads";
export const GET_ORG_ACCOUNT_WORKLOADS_SUCCESS = "get_org_account_workloads_success";
export const GET_ORG_ACCOUNT_WORKLOADS_FAILURE = "get_org_account_workloads_failure";

export const UPDATE_ORG_ACCOUNT_WORKLOAD = "update_org_account_workload";
export const UPDATE_ORG_ACCOUNT_WORKLOAD_SUCCESS = "update_org_account_workload_success";
export const UPDATE_ORG_ACCOUNT_WORKLOAD_FAILURE = "update_org_account_workload_failure";

export const GET_SCAN_SCHEDULES = "get_scan_schedules";
export const GET_SCAN_SCHEDULES_SUCCESS = "get_scan_schedules_success";
export const GET_SCAN_SCHEDULES_FAILURE = "get_scan_schedules_failure";

export const UPDATE_SCAN_SCHEDULE_FREQUENCY = "update_scan_schedule_frequency";
export const UPDATE_SCAN_SCHEDULE_FREQUENCY_SUCCESS = "update_scan_schedule_frequency_success";
export const UPDATE_SCAN_SCHEDULE_FREQUENCY_FAILURE = "update_scan_schedule_frequency_failure";

export const POST_FEATURE_CONFIGURATION = "post_feature_configuration";
export const POST_FEATURE_CONFIGURATION_SUCCESS = "post_feature_configuration_success";
export const POST_FEATURE_CONFIGURATION_FAILURE = "post_feature_configuration_failure";